import Survey from '../Survey/Survey';
import DashBoard from '../dashboard/DashBoard';
const Test = props => {
  return (      
    <Survey/>    
  );
}
  
// export default Test;
export default DashBoard;